import { render } from "./WorkflowCho.vue?vue&type=template&id=50ab72aa"
import script from "./WorkflowCho.vue?vue&type=script&lang=js"
export * from "./WorkflowCho.vue?vue&type=script&lang=js"

import "./WorkflowCho.vue?vue&type=style&index=0&id=50ab72aa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__